export default __webpack_public_path__ + "static/flight-delayed-heres-your-best-layover-plan-while-in-the-uk-glasgow-57b4ce5c0d45438f21e825e10930409d.jpg";